
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ThemeProvider, createTheme, Box } from "@mui/material";
import AuthLayout from './layouts.js/AuthLayout';
import AuthRegisterLayout from './layouts.js/RegisterLayout';
import DashboardLayout from './layouts.js/DashboardLayout';
import Test from './pages/AuthPages/test';
import Login from './pages/AuthPages/Login/Login';
import ForgetPassword from './pages/AuthPages/Login/ForgetPassword';
import VerificationScreen from './pages/AuthPages/Login/VerificationScreen';
import ResetPassword from './pages/AuthPages/Login/Resetpassword';
import Registeration from './pages/AuthPages/Registeration/Registeration';
import Location from './pages/AuthPages/Registeration/Locations';
import CreateProfile from './pages/AuthPages/Registeration/CreateProfile';
import Region from './pages/AuthPages/Registeration/Region';
import FaceScanning from './pages/AuthPages/Registeration/FaceScanning';
import RegisterationVerification from './pages/AuthPages/Registeration/RegisterationVerification';
import Dashboard from './pages/AdminPages/Dashboard/Dashboard';
import ChangePassword from './pages/AdminPages/Dashboard/ChangePassword';
import Remuneration from "./pages/AdminPages/Payments/Remuneration/Remuneration";
import Expenses from './pages/AdminPages/Payments/Expenses/Expenses';
import Messages from './pages/AdminPages/Messages/Inbox/Inbox';
import ReportsandStatistics from "./pages/AdminPages/Report & Statistics/Reports&Statistics";
import Notifications from './pages/AdminPages/Notifications.js/Notifications';
import Settings from './pages/AdminPages/Settings/Settings';
import PrivateRoute from './Routes/PrivateRoutes';
import PublicRoute from './Routes/PublicRoute';
import InviteFlowGuard from './Routes/InviteFlowGuard';
import OTPScreen from "./pages/AuthPages/Registeration/OTPScreen";
import { toast, Toaster } from "react-hot-toast";
import AnyError from "./components/anyError";
import Reports from "./pages/AdminPages/Reports/reports"
// import {interceptFetchErrors} from "./pages/Hooks/Intercept"
import useHealthCheck from './pages/Hooks/HealthCheck';
import GlobalHealthWrapper from './components/GlobalHealthCheck';
import ErrorBoundary from './components/ErrorBoundry';
import ScrollToTop from './components/ScrollToTop';
import AddressLocation from './pages/AuthPages/Registeration/AddressLocation';
import Absence from './pages/AdminPages/Absence/Absence';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import VerifyWorkerEmail from "./pages/AuthPages/Login/VerifyCompanyInvite";
import SetPassword from './pages/AuthPages/Login/SetPassword';
import FaceScanRegistration from './pages/AuthPages/FaceScanRegistration';
import UpdateInviteProfile from './pages/AuthPages/Registeration/UpdateInviteProfile';


import TodayPunch from './pages/AdminPages/Attendance/TodayPunch/TodayPunch';
import MonthlySummary from './pages/AdminPages/Attendance/MonthlySummary/MonthlySummary';
import MyTasks from './pages/AdminPages/TaskMangement/MyTasks/MyTasks';
import CalenderView from './pages/AdminPages/TaskMangement/CalenderView/taskCalenderView';
import TaskAttendanceHistory from './pages/AdminPages/TaskMangement/TaskAttendanceHistory/TaskAttendanceHistory';
import MyDocuments from "./pages/AdminPages/Documents/MyDocuments/myDocuments";
import CompanyDocuments from './pages/AdminPages/Documents/CompanyDocs/companyDocuments';
import AutomatedDocuments from './pages/AdminPages/Documents/AutomatedDocuments/AutomatedDocuments';
import RequestManagement from './pages/AdminPages/Request/Request';
import AdminApproval from './pages/AuthPages/Login/AdminApproval';
import VerifyInvite from './pages/AuthPages/Login/VerifyInvite';
import ForgetSetPassword from './pages/AuthPages/Login/forgetSetPassword';
import { useEffect } from 'react';
import { DynamicThemeProvider } from "./contexts/ThemeContext";
import Finance from "./pages/AdminPages/Finance/FinanceModule";
import Loan from "./pages/AdminPages/Loan/LoanModule";
import Lenders from './pages/AdminPages/Lenders/lendersModule';
import i18n from './i18n';
import useGlobalUnreadCount from './hooks/useGlobalUnreadCount';
  import { useJsApiLoader } from "@react-google-maps/api";
import { MAPS_API_KEY } from "./components/mapKey";
import LocatingPill from "./components/LocatingPill";
// Global unread count wrapper component
const GlobalUnreadCountWrapper = ({ children }) => {
  useGlobalUnreadCount();
  return children;
};
const theme = createTheme({
  palette: {
    primary: {
      main: "#006EC2",
      text: "#8B8D97",
    },
    tertiary: {
      main: "#2C384C", // Tertiary color
    },
    text: {
      primary: "#8B8D97",
    },
  },
  typography: {

    h1: {
      fontFamily: "Volkhov, serif",
      fontSize: "52px",
      fontWeight: 400,
      lineHeight: 1.1,
    },
    h2: {

      fontSize: "58px",
      fontWeight: 600,
      lineHeight: 1.1,
    },
    h3: {

      fontSize: "52px",
      fontWeight: 400,
      lineHeight: 1.1,
    },
    h4: {

      fontSize: "68px",
      fontWeight: 700,
      lineHeight: 1.1,
    },
    body1: {

      fontSize: "28px",
      fontWeight: 500,
      lineHeight: 1.7,
    },
  },
});
function App() {


  // Get browser language function
  const getBrowserLanguage = () => {
    const browserLang = navigator.language || navigator.userLanguage;
    console.log('Browser language detected:', browserLang);

    // Extract language code (e.g., 'es-ES' -> 'es', 'en-US' -> 'en')
    const langCode = browserLang.split('-')[0].toLowerCase();
    console.log('🌐 Language code:', langCode);

    // Map to supported languages
    const supportedLanguages = {
      'es': 'es', // Spanish
      'en': 'en', // English
    };

    // Return supported language or default to English
    const detectedLang = supportedLanguages[langCode] || 'en';
    console.log('🌐 Mapped to language:', detectedLang);

    return detectedLang;
  };


  // useEffect(() => {

  //   // if (!savedLang) {
  //   const detectedLanguage = getBrowserLanguage();
  //   console.log('🌐 Setting language to:', detectedLanguage);
  //   i18n.changeLanguage(detectedLanguage);
  //   localStorage.setItem('lang', detectedLanguage);
  //   // }
  // }, []);





 useEffect(() => {
     const savedLang = localStorage.getItem("i18nextLng");
     
     
     if (!savedLang) {
     // 👶 First-time user → use browser language
     const detectedLanguage = getBrowserLanguage();
     console.log("🌍 No saved language, using browser:", detectedLanguage);
     i18n.changeLanguage(detectedLanguage);
     } else {
     // 🔒 Returning user → respect their choice
     console.log("🔒 Using saved language:", savedLang);
     }
     }, []);



     const { isLoaded } = useJsApiLoader({
  googleMapsApiKey: MAPS_API_KEY,
  libraries: ["places"],
});

if (!isLoaded) return null;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Router>
        {/* <ThemeProvider theme={theme}> */}
        <DynamicThemeProvider>
          <Toaster />
          <LocatingPill />
          {/* <GlobalHealthWrapper />  */}
          <ScrollToTop />
          <Routes>
            <Route element={<PublicRoute><AuthLayout /></PublicRoute>}>
            <Route element={<AuthLayout />}>
              <Route path="/" element={<Login />} />
              <Route path="/worker/verify-email" element={<VerifyWorkerEmail />} />
              {/* <Route path="/set-password" element={<SetPassword />} /> */}
              <Route path="/forget-password" element={<ForgetPassword />} />
              <Route path="/forget-set-password" element={<ForgetSetPassword />} />
              <Route path='/verification' element={<VerificationScreen />} />
              <Route path='/reset-password' element={<ResetPassword />} />
              {/* <Route path="/account-executive/account-executive/verify-invite" element={<VerifyInvite/>} />
        <Route path="/set-password" element={<InviteResetPassword/>} /> */}
</Route>
            </Route>

            <Route element={<AuthLayout />}>
              <Route path="/something-went-wrong" element={<AnyError />} />
            </Route>


            <Route element={<PublicRoute><AuthRegisterLayout /></PublicRoute>}>   
            <Route element={<AuthRegisterLayout />}>
              <Route path="/register" element={<Registeration />} />
              <Route path="/admin-approval" element={<AdminApproval />} />
              <Route element={<InviteFlowGuard />}>
                <Route path="/worker/verify-invite" element={<VerifyInvite />} />
                <Route path="/set-password" element={<SetPassword />} />
                <Route path="/face-scan-registration" element={<FaceScanRegistration />} />
                <Route path="/update-invite-profile" element={<UpdateInviteProfile />} />
              </Route>
              <Route path="/otp-screen" element={<OTPScreen />} />
              <Route path="/location" element={<Location />} />
              <Route path="/create-profile" element={<CreateProfile />} />
              <Route path="/address-location" element={<AddressLocation />} />
              <Route path="/region" element={<Region />} />
              <Route path="/face-scanning" element={<FaceScanning />} />
              <Route path="/registration-verification" element={<RegisterationVerification />} />
            </Route>
            </Route>
            <Route element={<PrivateRoute><GlobalUnreadCountWrapper><DashboardLayout /></GlobalUnreadCountWrapper></PrivateRoute>}>
            {/* <Route element={<DashboardLayout />}> */}
              <Route path="/dashboard" element={<Dashboard />} />
              {/* <Route path="/change-password" element={<ChangePassword/>}/> */}
              <Route path="/today-punch" element={<TodayPunch />} />
              <Route path="/monthly-summary" element={<MonthlySummary />} />
              <Route path="/my-tasks" element={<MyTasks />} />
              <Route path="/task-attendance-history" element={<TaskAttendanceHistory />} />
              <Route path="/calender-view" element={<CalenderView />} />
              <Route path="/sent-documents" element={<MyDocuments />} />
              <Route path="/received-documents" element={<CompanyDocuments />} />
              <Route path="/automated-documents" element={<AutomatedDocuments />} />
              <Route path="/remuneration" element={<Remuneration />} />
              <Route path="/expenses" element={<Expenses />} />


              <Route path="/finance" element={<Finance />} />
              <Route path="/lenders" element={<Lenders />} />
              <Route path="/loan" element={<Loan />} />

              <Route path="/request-management" element={<RequestManagement />} />

              <Route path="/messages" element={<Messages />} />
             
        

              <Route path="/reports" element={<Reports />} />
              <Route path="/reports-services" element={< ReportsandStatistics />} />
              <Route path="/absence" element={<Absence />} />
              <Route path="/notifications" element={< Notifications />} />
              <Route path="/settings" element={< Settings />} />
            </Route>
            {/* </Route> */}

          </Routes>

          {/* </ThemeProvider> */}
        </DynamicThemeProvider>
      </Router>
    </LocalizationProvider>
  );
}

export default App;
